'use client';

import { useEffect } from 'react';
import { getStore } from '~/mobx/AppStore';

type Props = {
    sid: string;
    standAdminRedirectUrl: string;
};

const Client = (props: Readonly<Props>) => {
    const { sid, standAdminRedirectUrl } = props;

    useEffect(() => {
        const { standAdminStore } = getStore();
        standAdminStore.setSid(sid);
        standAdminStore.setStandAdminRedirectUrl(standAdminRedirectUrl);
    }, [sid, standAdminRedirectUrl]);

    return null;
};

export default Client;
